import styled from 'styled-components';

export const Wrapper = styled.div`
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100vh;

    img {
        object-fit: cover;
        width: 50px;
    }
`;

export const ComponentLoaderWrapper = styled.div`
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-top: 5rem;

    img {
        object-fit: cover;
        width: 40px;
    }
`;
